import type { RGBA } from "./rgba-color";

type RgbaArray = [red: number, green: number, blue: number, alpha?: number];
const rgbaToArray = (rgba: RGBA): Required<RgbaArray> => {
    return [rgba.red, rgba.green, rgba.blue, rgba.alpha];
};

export { rgbaToArray };
export type { RgbaArray };
